import { createReducer, on, Action } from '@ngrx/store';
import { AutomatchState } from '../state/automatch.state';
import {
    clearAutomatchGroupedWinningRuleset,
    loadAutomatchGroupedWinningRulesetFailure,
    loadAutomatchGroupedWinningRulesetSuccess
} from '../actions/automatch.actions';

const initialState: AutomatchState = {
    groupedWinningRuleset: null
};

const reducer = createReducer(
    initialState,
    on(loadAutomatchGroupedWinningRulesetSuccess, (state, action) => ({
        groupedWinningRuleset: action.groupedWinningRuleset
    })),
    on(loadAutomatchGroupedWinningRulesetFailure, () => ({
        groupedWinningRuleset: null
    })),
    on(clearAutomatchGroupedWinningRuleset, () => ({
        groupedWinningRuleset: null
    }))
);

export function automatchReducer(state: AutomatchState | undefined, action: Action) {
    return reducer(state, action);
}
